import { useAuthStore } from "../stores/authStore";
import Reports from "./Reports";
import UserReports from "./UserReport";

/**
 * ReportsWrapper - Conditionally renders Reports or UserReports based on user scope
 * - If scope is "tenant" → display Reports.tsx (agency report)
 * - If scope is "org" → display UserReports.tsx (customer/organization report)
 */
export default function ReportsWrapper() {
  const user = useAuthStore((state) => state.user);

  // Show customer report for org scope users
  if (user?.scope === "org") {
    return <UserReports />;
  }

  // Show agency report for tenant scope users (and platform as fallback)
  return <Reports />;
}
